import React, { useState } from "react";
import './LandingPage.scss'
// import homeLogo from "../assets/icons/cubegame_logo.png"
import "../commonComponents/BannerGame.scss"

const LandingPage = ({ banners ,subUrl,homeLogo}) => {
    const [loading, setLoading] = useState(false);
    const openService=(e)=>{
        e.preventDefault();
    }

    const handleRedirection=()=>
    {
        window.open(subUrl,"_self")
    }
    if (loading) return <div className="loader-container bg" style={{ backgroundColor: "#FF7600" }}>
        <div className="lds" >
        </div></div>;
    return (
        <div className="container lpContainer">
            <img
                className="logo"
                src={homeLogo}></img>

                <figure className="image is-2by1 slider-image-container">
                    <img src={banners?.[0].img} alt={banners?.[0].title} className="px-3" />
                    <div className="image-overlay">
                        <div className="title">
                            SWITCH TO THE ULTIMATE
                        </div>
                        <div className="subtitle">
                            GAMING EXPERIENCE
                        </div>
                        <div className="button" onClick={openService}>
                           PLAY NOW
                        </div>
                    </div>
                </figure>
            <div className="text">
                CubeGames
            </div>
            <div className="text2">
                Anda telah berhasil berlangganan layanan Cubegames . Harga 2220/sms (sudah termasuk ppn)
            </div>
            <button className="subBtn" onClick={handleRedirection}>
                Subscribe
            </button>
        </div>
    )
}

export default LandingPage;